import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getBussinessTypeBookServiceData } from "@tCentro/Services/CENCredAppBussinessTypeService";



export interface GetBusinessTypeRequest extends HasOnSuccess<GetBusinessTypeResponse>, HasOnError {}
export interface GetBusinessTypeResponse {
    [key: string]: any; 
}

type HandlerType = ApiHandler<GetBusinessTypeRequest, GetBusinessTypeResponse & HasOnError>;


export const DispatchBeginBusinessTypeLoad: HandlerType = props => {
    (props as any).dispatch({
        type: "Custom/BusinessType/BeginLoad",
    });
};


export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {}; // no input required for this API
};


export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await getBussinessTypeBookServiceData();
    } catch (error) {
        if (isApiError(error)) {
            const errorMsg = error.errorJson?.message || error.errorMessage;
            if (errorMsg) {
                props.apiResult = { ...props.apiResult, errorMessage: errorMsg };
            }
        }
    }
};


export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.apiResult?.errorMessage) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};


export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.apiResult?.errorMessage) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};


export const DispatchCompleteBusinessTypeLoad: HandlerType = props => {
    if (!props.apiResult) return;
    (props as any).dispatch({
        type: "Custom/BusinessType/CompletedLoad",
        result: props.apiResult,
    });
};


export const chain = [
    DispatchBeginBusinessTypeLoad,
    PopulateApiParameter,
    SendDataToApi,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    DispatchCompleteBusinessTypeLoad,
];


const getBusinessTypeHandler = createHandlerChainRunner(chain, "getBusinessTypeHandler");

export default getBusinessTypeHandler;
